import { OriginShippingRate } from '@/models/common/origin-shipping-rate';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { BusinessShippingRateService } from './business-shipping-rate-service';

export class BusinessShippingRate {
    public id: number = 0;
    public businessId: number = 0;
    public businessAllowedPaymentOnHandingOver: boolean = false;
    public name?: string;
    public description?: string;
    public origin: OriginShippingRate = new OriginShippingRate();
    public services: BusinessShippingRateService[] = [];

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            {
                origin: json.origin ? new OriginShippingRate(json.origin) : new OriginShippingRate(),
                services: json.services ? json.services.map((service: any) => new BusinessShippingRateService(service)) : [],
            });
    }

    public clone(): BusinessShippingRate {
        const shippingRate: BusinessShippingRate = new BusinessShippingRate();

        shippingRate.id = this.id;
        shippingRate.businessId = this.businessId;
        shippingRate.businessAllowedPaymentOnHandingOver = this.businessAllowedPaymentOnHandingOver;
        shippingRate.name = this.name;
        shippingRate.description = this.description;
        shippingRate.origin = this.origin.clone();
        shippingRate.services = this.services.map((service) => service.clone());

        return shippingRate;
    }
}
